{
  "valid": "Derīgs"
}
